/** Agent Desktop callback offer lifecycle: shown, Call Now in flight, dialed (card closed, attempt kept for reconciliation). */
export enum ScheduledCallOfferPhase {
  Idle = 0,
  Offered = 1,
  Starting = 2,
  Dialing = 3,
}
